import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.css'
import CircularProgress from '@mui/material/CircularProgress';

const userAgent = window.navigator.userAgent;

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
console.log('userAgent' + userAgent)
const ComponentToRender = React.lazy(() => isMobile ? import('./App') : import('./Pc'));  // 모바일 환경이면 App 컴포넌트, 아니면 Pc 컴포넌트를 선택합니다.
// console.log(isMobile)

const centerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh' // 뷰포트의 높이를 기준으로 100%로 설정하여 화면 전체 높이를 차지하게 함
};
const appBack = async () => { //API에서 초기 데이터를 가져오는 비동기 함수
  // alert('aaa')
  
};
createRoot(document.getElementById('root')).render(
  <Suspense fallback={<div style={centerStyle}></div>}>
    
  <ComponentToRender />
</Suspense>
);
